module.exports = __webpack_public_path__ + "img/ex_in_tooth_washer.prt.852f6ea9.jpg";